import {
  ButtonSizes,
  CheckboxSizes,
  PaymentProgressSizes,
  RadioButtonSizes,
  TextSizes,
  useIsBreakpointLargeAndUp,
  useIsTheme,
  Theme,
} from '@afterpaytouch/core'

interface ResponsiveSizes {
  buttonSize: ButtonSizes
  checkboxSize: CheckboxSizes
  harveyBallCaptionSize: TextSizes
  harveyBallSize: PaymentProgressSizes
  headingSize: TextSizes
  radioSize: RadioButtonSizes
  sectionHeadingSize: TextSizes
  smallTextSize: TextSizes
  extraSmallTextSize: TextSizes
  textSize: TextSizes
}

export const useCheckoutSizes = (): ResponsiveSizes => {
  const isDesktop = useIsBreakpointLargeAndUp()
  const isAPTheme = useIsTheme(Theme.AP)

  // Create the initial sizes object based on responsive design
  const sizes: ResponsiveSizes = {
    buttonSize: 'Large',
    checkboxSize: isDesktop ? 'Medium' : 'Small',
    extraSmallTextSize: isDesktop ? 'XS' : 'XXS',
    harveyBallCaptionSize: isDesktop ? 'S' : 'XS',
    harveyBallSize: isDesktop ? 'Regular' : 'Small',
    headingSize: 'XXL',

    radioSize: 'Medium',
    sectionHeadingSize: 'L',
    smallTextSize: isAPTheme ? 'S' : 'XS',
    textSize: 'M',
  }

  return sizes
}
